import * as Dialog from '@radix-ui/react-dialog';
import { AnimatePresence } from 'motion/react';
import React, { useEffect } from 'react';
import { DialogContent, DialogOverlay } from './Dialog.styled';
/**
 * @public
 */
const PclnDialog = ({
  ariaDescription,
  ariaTitle,
  borderRadius = '2xl',
  children,
  defaultOpen = false,
  footerContent,
  fullWidth = false,
  headerColorScheme = 'heading',
  headerContent,
  headerContentProps,
  headerIcon,
  headerShowCloseButton = false,
  hugColor,
  innerContentOverflow = 'scroll',
  open,
  scrimColor = 'dark',
  scrimDismiss = true,
  sheet = false,
  showCloseButton = true,
  showScrollShadow,
  size = 'md',
  triggerNode,
  zIndex = 'overlay',
  overflowX = 'auto',
  overflowY = 'auto',
  onOpenChange,
  shouldDisableTabIndex
}) => {
  const [_open, setOpen] = React.useState(open ?? defaultOpen);
  useEffect(() => setOpen(open), [open]);
  const handleOpenChange = newOpen => {
    onOpenChange?.(newOpen);
    setOpen(newOpen);
  };
  return React.createElement(Dialog.Root, {
    open: _open,
    onOpenChange: handleOpenChange,
    defaultOpen: defaultOpen
  }, React.createElement(Dialog.Trigger, {
    asChild: true
  }, triggerNode), React.createElement(AnimatePresence, null, _open && React.createElement(DialogOverlay, {
    scrimDismiss: scrimDismiss,
    scrimColor: scrimColor,
    sheet: sheet,
    zIndex: zIndex
  }, React.createElement(DialogContent, {
    overflowX: overflowX,
    overflowY: overflowY,
    ariaDescription: ariaDescription,
    ariaTitle: ariaTitle,
    borderRadius: borderRadius,
    footerContent: footerContent,
    fullWidth: fullWidth,
    headerColorScheme: headerColorScheme,
    headerContent: headerContent,
    headerContentProps: headerContentProps,
    headerIcon: headerIcon,
    headerShowCloseButton: headerShowCloseButton,
    hugColor: hugColor,
    innerContentOverflow: innerContentOverflow,
    onOpenChange: handleOpenChange,
    scrimDismiss: scrimDismiss,
    sheet: sheet,
    showCloseButton: showCloseButton,
    size: size,
    showScrollShadow: showScrollShadow,
    shouldDisableTabIndex: shouldDisableTabIndex
  }, children))));
};
PclnDialog.displayName = 'Dialog';
export { PclnDialog as Dialog };